import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Http, RequestOptions } from '@angular/http';
import { AuthHttp, AuthConfig } from 'angular2-jwt';

import { router } from './auth.routes';
import { LoginComponent } from './login.component';
import { AuthService } from './auth.service';
import { DisconnectedGuard } from './disconnected.guard';
import { TranslateModule } from '@ngx-translate/core';
import { InputTrimModule } from 'ng2-trim-directive';

export function authHttpServiceFactory(http: Http, options: RequestOptions) {
  return new AuthHttp(
    new AuthConfig({
      tokenName: 'token',
      noClientCheck: true,
      tokenGetter: () => AuthService.retrieve(AuthService.TOKEN_KEY),
      globalHeaders: [{ 'Content-Type': 'application/json' }]
    }),
    http,
    options
  );
}

@NgModule({
  declarations: [LoginComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, router, TranslateModule, InputTrimModule],
  providers: [
    {
      provide: AuthHttp,
      useFactory: authHttpServiceFactory,
      deps: [Http, RequestOptions]
    },
    DisconnectedGuard
  ]
})
export class AuthModule {}



// WEBPACK FOOTER //
// ./src/app/modules/auth/auth.module.ts